import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["togglable"]

  static values = {
    toggle: { type: Boolean, default: true },
    toggleOnText: { type: String, default: "On" },
    toggleOffText: { type: String, default: "Off" },
  }

  toggle() {
    this.flipState()
  }

  flipState() {
    this.toggleValue = !this.toggleValue
  }

  toggleValueChanged() {
    this.updateText()
  }

  newText() {
    return this.toggleValue ? this.toggleOnTextValue : this.toggleOffTextValue
  }

  updateText() {
    this.togglableTarget.innerText = this.newText()
  }
}
